/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

export const CLEAR_CREEK_PERMIT_ID = '250848';
export const CAPE_HATTERAS_PERMIT_ID = '249978';
export const FLORIDA_OHV_PERMIT_ID = '74048';
export const MARIPOSA_PERMIT_ID = '274348';
export const CAPE_LOOKOUT_PERMIT_ID = '3332402';
export const ASSATEAGUE_PERMIT_ID = '3332403';
export const BIG_CYPRESS_PERMIT_ID = '3332404';
export const BIG_CYPRESS_LANDS_PERMIT_ID = '3332405';

export const validPermitIds = [
    CLEAR_CREEK_PERMIT_ID,
    CAPE_HATTERAS_PERMIT_ID,
    FLORIDA_OHV_PERMIT_ID,
    MARIPOSA_PERMIT_ID,
    CAPE_LOOKOUT_PERMIT_ID,
    ASSATEAGUE_PERMIT_ID,
    BIG_CYPRESS_PERMIT_ID,
    BIG_CYPRESS_LANDS_PERMIT_ID,
];

export const isInvalidPermitId = (permitId) => {
    return validPermitIds.indexOf(permitId) === -1;
};

export const FIELD_SALES_SALES_CHANNEL = 1;
export const CALL_CENTER_SALES_CHANNEL = 2;

export const VEHICLE_PERMITS_DISABLE_MODIFY_LIST = [
    CAPE_HATTERAS_PERMIT_ID,
    FLORIDA_OHV_PERMIT_ID,
    CAPE_LOOKOUT_PERMIT_ID,
    ASSATEAGUE_PERMIT_ID,
    BIG_CYPRESS_PERMIT_ID,
    BIG_CYPRESS_LANDS_PERMIT_ID,
];

export const CLEAR_CREEK_PERMIT_TYPES = {
    CK_VEHICLE_PERMIT: 'CK_VEHICLE_PERMIT',
    ATV_PERMIT: 'ATV_PERMIT',
    ACEC_PERMIT: 'ACEC_PERMIT',
};

export const CAPE_HATTERAS_PERMIT_TYPES = {
    TEN_DAYS_PERMIT: 'CHS_TEN_DAYS_PERMIT',
    ANNUAL_PERMIT: 'CHS_ANNUAL_PERMIT',
};

export const FLORIDA_OHV_PERMIT_TYPES = {
    OHV_THREE_DAYS_PERMIT: 'FL_OHV_THREE_DAYS_PERMIT',
    OHV_SEVEN_DAYS_PERMIT: 'FL_OHV_SEVEN_DAYS_PERMIT',
    OHV_ANNUAL_PERMIT: 'FL_OHV_ANNUAL_PERMIT',
};

export const ALL_DIVISIONS_MAPPING = {
    CK_VEHICLE_PERMIT: '557',
    ATV_PERMIT: '555',
    ACEC_PERMIT: '556',
    CHS_TEN_DAYS_PERMIT: '866',
    CHS_ANNUAL_PERMIT: '824',
    CLS_ANNUAL_PERMIT: '333240201',
    FL_OHV_THREE_DAYS_PERMIT: '407520',
    FL_OHV_SEVEN_DAYS_PERMIT: '407521',
    FL_OHV_ANNUAL_PERMIT: '407522',
};

export const ALL_PERMIT_TYPES_MAPPING = {
    CK_VEHICLE_PERMIT: '1737955283',
    ATV_PERMIT: '1737958263',
    ACEC_PERMIT: '1737958560',
    CHS_TEN_DAYS_PERMIT: '2498471830',
    CHS_ANNUAL_PERMIT: '2498472401',
    CLS_ANNUAL_PERMIT: '333240201',
    FL_OHV_THREE_DAYS_PERMIT: '1966951977',
    FL_OHV_SEVEN_DAYS_PERMIT: '1966952807',
    FL_OHV_ANNUAL_PERMIT: '1966945087',
    TONTO_SIX_MONTH_PERMIT: '33324011',
};

export const ANNUAL_PERMIT_TYPES = [ALL_DIVISIONS_MAPPING.CHS_ANNUAL_PERMIT];

export const ALL_DIVISION_TO_TYPE_MAPPING = {
    557: '1737955283',
    555: '1737958263',
    556: '1737958560',
    866: '2498471830',
    824: '2498472401',
    333240201: '333240201',
    407520: '1966951977',
    407521: '1966952807',
    407522: '1966945087',
    33324011: '33324011',
    333240301: '333240301',
    333240302: '333240302',
    333240401: '333240401',
    333240501: '333240501',
};

export const SALES_CURRENTLY_BLOCKED =
    'Sales are temporarily unavailable for this facility. Please try again later.';

export const RECAPTCHA_FAILED_MESSAGE =
    'We could not verify this request. Please try again from a different browser or network connection.';

// The batch issuance endpoint pins this action name - a token minted with any
// other action fails verification server-side.
export const RECAPTCHA_BATCH_ACTION = 'create_issuances';

export const BATCH_INCOMPLETE_MESSAGE =
    'We could not finish adding all of your permits, and some may have been added to your cart. Please review your cart before trying again.';

// The batch endpoint returns the issuances it created before failing, so the
// ones already in the cart can be named and only the rest left on the page.
export const getBatchPartialMessage = (createdCount) =>
    `${createdCount} of your permits ${
        createdCount === 1 ? 'was' : 'were'
    } added to your cart. The permits below were not - please review them and try again.`;

export const getClassName = (error, displayError) => {
    if (error && displayError) {
        return 'rec-error';
    }
    return '';
};

export const VEHICLE_PERMIT_DATETIME_FORMAT = 'MM/DD/YYYY hh:mm a z';
export const VEHICLE_PERMIT_DATE_FORMAT = 'YYYY-MM-DD';

export const generateNewIds = () => {
    // Math.random should be unique because of its seeding algorithm.
    // Convert it to base 36 (numbers + letters), and grab the first 9 characters
    // after the decimal.
    return Math.random().toString(36).substr(2, 9);
};

export function toTitleCase(str) {
    if (str) {
        return str.replace(/\w*/g, (txt) => {
            return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        });
    }
    return str;
}

export const COUNTRY_LIST = [
    'Afghanistan',
    'Albania',
    'Algeria',
    'Andorra',
    'Angola',
    'Antigua & Deps',
    'Argentina',
    'Armenia',
    'Australia',
    'Austria',
    'Azerbaijan',
    'Bahamas',
    'Bahrain',
    'Bangladesh',
    'Barbados',
    'Belarus',
    'Belgium',
    'Belize',
    'Benin',
    'Bhutan',
    'Bolivia',
    'Bosnia Herzegovina',
    'Botswana',
    'Brazil',
    'Brunei',
    'Bulgaria',
    'Burkina',
    'Burundi',
    'Cambodia',
    'Cameroon',
    'Canada',
    'Cape Verde',
    'Central African Rep',
    'Chad',
    'Chile',
    'China',
    'Colombia',
    'Comoros',
    'Congo',
    'Congo {Democratic Rep}',
    'Costa Rica',
    'Croatia',
    'Cuba',
    'Cyprus',
    'Czech Republic',
    'Denmark',
    'Djibouti',
    'Dominica',
    'Dominican Republic',
    'East Timor',
    'Ecuador',
    'Egypt',
    'El Salvador',
    'Equatorial Guinea',
    'Eritrea',
    'Estonia',
    'Ethiopia',
    'Fiji',
    'Finland',
    'France',
    'Gabon',
    'Gambia',
    'Georgia',
    'Germany',
    'Ghana',
    'Greece',
    'Grenada',
    'Guatemala',
    'Guinea',
    'Guinea-Bissau',
    'Guyana',
    'Haiti',
    'Honduras',
    'Hungary',
    'Iceland',
    'India',
    'Indonesia',
    'Iran',
    'Iraq',
    'Ireland {Republic}',
    'Israel',
    'Italy',
    'Ivory Coast',
    'Jamaica',
    'Japan',
    'Jordan',
    'Kazakhstan',
    'Kenya',
    'Kiribati',
    'Korea North',
    'Korea South',
    'Kosovo',
    'Kuwait',
    'Kyrgyzstan',
    'Laos',
    'Latvia',
    'Lebanon',
    'Lesotho',
    'Liberia',
    'Libya',
    'Liechtenstein',
    'Lithuania',
    'Luxembourg',
    'Macedonia',
    'Madagascar',
    'Malawi',
    'Malaysia',
    'Maldives',
    'Mali',
    'Malta',
    'Marshall Islands',
    'Mauritania',
    'Mauritius',
    'Mexico',
    'Micronesia',
    'Moldova',
    'Monaco',
    'Mongolia',
    'Montenegro',
    'Morocco',
    'Mozambique',
    'Myanmar, {Burma}',
    'Namibia',
    'Nauru',
    'Nepal',
    'Netherlands',
    'New Zealand',
    'Nicaragua',
    'Niger',
    'Nigeria',
    'Norway',
    'Oman',
    'Pakistan',
    'Palau',
    'Panama',
    'Papua New Guinea',
    'Paraguay',
    'Peru',
    'Philippines',
    'Poland',
    'Portugal',
    'Qatar',
    'Romania',
    'Russian Federation',
    'Rwanda',
    'St Kitts & Nevis',
    'St Lucia',
    'Saint Vincent & the Grenadines',
    'Samoa',
    'San Marino',
    'Sao Tome & Principe',
    'Saudi Arabia',
    'Senegal',
    'Serbia',
    'Seychelles',
    'Sierra Leone',
    'Singapore',
    'Slovakia',
    'Slovenia',
    'Solomon Islands',
    'Somalia',
    'South Africa',
    'South Sudan',
    'Spain',
    'Sri Lanka',
    'Sudan',
    'Suriname',
    'Swaziland',
    'Sweden',
    'Switzerland',
    'Syria',
    'Taiwan',
    'Tajikistan',
    'Tanzania',
    'Thailand',
    'Togo',
    'Tonga',
    'Trinidad & Tobago',
    'Tunisia',
    'Turkey',
    'Turkmenistan',
    'Tuvalu',
    'Uganda',
    'Ukraine',
    'United Arab Emirates',
    'United Kingdom',
    'United States',
    'Uruguay',
    'Uzbekistan',
    'Vanuatu',
    'Vatican City',
    'Venezuela',
    'Vietnam',
    'Yemen',
    'Zambia',
    'Zimbabwe',
];

export function monthValidator(input) {
    const parsed = {
        isValid: false,
        formattedValue: null,
        errorText: null,
    };
    const errors = {
        invalidChar: 'Month should only be numbers',
        invalidLength: 'Month should be between 1 and 12',
    };

    let cleanedValue = '';
    const monthPattern = /^(0?[1-9]|1[0-2])$/;
    const numberPattern = /[0-9]/;
    const allowedPattern = /[\W\d]/;

    if (monthPattern.test(input)) {
        parsed.isValid = true;
        parsed.formattedValue = input;

        return parsed;
    }

    if (typeof input === 'string' && input.length) {
        for (let i = 0; i < input.length; i += 1) {
            if (numberPattern.test(input[i])) {
                cleanedValue += input[i];
            } else if (!allowedPattern.test(input[i])) {
                parsed.errorText = errors.invalidChar;
                return parsed;
            }
        }
    }

    if (cleanedValue.length !== 1 || cleanedValue.length !== 2) {
        parsed.errorText = errors.invalidLength;
        return parsed;
    }

    parsed.isValid = true;
    parsed.formattedValue = cleanedValue;

    return parsed;
}

export function dayValidator(input) {
    const parsed = {
        isValid: false,
        formattedValue: null,
        errorText: null,
    };
    const errors = {
        invalidChar: 'Day should only be numbers',
        invalidLength: 'Day should be between 1 and 31',
    };

    let cleanedValue = '';
    const dayPattern = /\b(0?[1-9]|[1-2][0-9]|3[0-1])\b/;
    const numberPattern = /[0-9]/;
    const allowedPattern = /[\W\d]/;

    if (dayPattern.test(input)) {
        parsed.isValid = true;
        parsed.formattedValue = input;

        return parsed;
    }

    if (typeof input === 'string' && input.length) {
        for (let i = 0; i < input.length; i += 1) {
            if (numberPattern.test(input[i])) {
                cleanedValue += input[i];
            } else if (!allowedPattern.test(input[i])) {
                parsed.errorText = errors.invalidChar;
                return parsed;
            }
        }
    }

    if (cleanedValue.length !== 1 || cleanedValue.length !== 2) {
        parsed.errorText = errors.invalidLength;
        return parsed;
    }

    parsed.isValid = true;
    parsed.formattedValue = cleanedValue;

    return parsed;
}

export function yearValidator(input) {
    const parsed = {
        isValid: false,
        formattedValue: null,
        errorText: null,
    };
    const errors = {
        invalidChar: 'Year should only be numbers',
        invalidLength: 'Year should be 4 digits',
    };

    let cleanedValue = '';
    const yearPattern = /^\d{4}$/;
    const numberPattern = /[0-9]/;
    const allowedPattern = /[\W\d]/;

    if (yearPattern.test(input)) {
        parsed.isValid = true;
        parsed.formattedValue = input;

        return parsed;
    }

    if (typeof input === 'string' && input.length) {
        for (let i = 0; i < input.length; i += 1) {
            if (numberPattern.test(input[i])) {
                cleanedValue += input[i];
            } else if (!allowedPattern.test(input[i])) {
                parsed.errorText = errors.invalidChar;
                return parsed;
            }
        }
    }

    if (cleanedValue.length !== 1 || cleanedValue.length !== 2) {
        parsed.errorText = errors.invalidLength;
        return parsed;
    }

    parsed.isValid = true;
    parsed.formattedValue = cleanedValue;

    return parsed;
}
